export const waitingListRequiredFields = [
  'teamName',
  'email',
  'firstName',
  'lastName'
] as const

export const waitingListAdditionalFields = [
  'gender',
  'birthDate',
  'phoneNumber',
  'nationality',
  'postalAddress'
] as const
